// SPDX-License-Identifier: AGPL-3.0-or-later

import {BADGE_ORDER_MAX} from '@fluxer/schema/src/domains/badge/BadgeVisibilitySchemas';

const CATALOG = 'catalog';
const DEFAULT_ORDER = [
	'staff',
	'premium',
	'premium_package',
	'booster',
	CATALOG,
	'bug_hunter',
	'bot_developer',
	'partner',
	'premium_sequence',
];
const CATALOG_KEY = /^(?:badge-)?\d+$/;

const profileKey = (key: string) => (/^\d+$/.test(key) ? `badge-${key}` : key);

export function defaultBadgeRank(key: string): number {
	const rank = DEFAULT_ORDER.indexOf(CATALOG_KEY.test(key) ? CATALOG : key);
	return rank === -1 ? DEFAULT_ORDER.length : rank;
}

export function sortByBadgeOrder<T>(
	items: ReadonlyArray<T>,
	keyOf: (item: T) => string,
	order: ReadonlyArray<string>,
): Array<T> {
	const rank = new Map<string, number>();
	for (const key of order) {
		const normalized = profileKey(key);
		if (!rank.has(normalized)) rank.set(normalized, rank.size);
	}
	const rankOf = (item: T) => rank.get(profileKey(keyOf(item))) ?? rank.size;
	return [...items].sort((a, b) => rankOf(a) - rankOf(b));
}

export function toOrderPayload(keys: ReadonlyArray<string>): Array<string> {
	return keys.map((key) => key.replace(/^badge-/, '')).slice(0, BADGE_ORDER_MAX);
}
